import { getCardDecorations } from "./utils/getCardDecorations/getCardDecorations";
import { getDefaultSubjectIcon } from "./utils/getDefaultSubjectIcon/getDefaultSubjectIcon";
import { getPlanitLinkInfo } from "./utils/getPlanitLinkInfo/getPlanitLinkInfo";
import { getSchemeExploreLink } from "./utils/getSchemeExploreLink/getSchemeExploreLink";
import { getSubjectDescription } from "./utils/getSubjectDescription/getSubjectDescription.ts";
import { getSubjectDisplayLabel } from "./utils/getSubjectDisplayLabel/getSubjectDisplayLabel";
import { mapSubjectUiData } from "./utils/mapSubjectUiData/mapSubjectUiData";

const EXTRA_TAG = {
  variant: "pink",
  label: "extra",
} as const;

const ULTIMATE_TAG = {
  variant: "pink",
  label: "ultimate",
} as const;

const DEFAULT_ADD_ON_TAG = {
  variant: "light-blue",
  label: "add-on",
} as const;

type Tag = typeof EXTRA_TAG | typeof ULTIMATE_TAG | typeof DEFAULT_ADD_ON_TAG;

export const SubjectHelper = {
  mapSubjectUiData,
  getSubjectIcon: getDefaultSubjectIcon,
  getLabel: getSubjectDisplayLabel,
  getDescription: getSubjectDescription,
  getPlanitLinkInfo,
  getCardDecorations,
  getExploreLink: getSchemeExploreLink,
  getSubjectAddOnTags: (slug: string): Tag[] => {
    switch (slug) {
      case "science":
        return [EXTRA_TAG, ULTIMATE_TAG];
      case "design-tech":
        return [EXTRA_TAG, ULTIMATE_TAG];
      case "pshe":
        return [ULTIMATE_TAG];
      default:
        return [DEFAULT_ADD_ON_TAG];
    }
  },
  //   art: {
  //   icon: "Palette",
  //   displayLabel: i18n.t("subjects.art.label", { ns: COMMON_NS }),
  //   description: i18n.t("subjects.art.description", { ns: COMMON_NS }),
  //   imageUrl: ArtImage,
  //   schemeLink: "/resources/champions-of-art",
  // },
};
